import * as Sentry from '@sentry/browser';

import { store } from '../redux';
import { getUserInfo, sessionStoreSelector } from '../redux/session/selectors';
import {
  CustomError,
  ErrorLevels,
  ExceptionFormater,
  getAPIErrorMessages,
} from '../utils/errors';

export default function sentryInit() {
  return Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.NODE_ENV,
  });
}

export function captureException(
  e: any,
  severity: ErrorLevels = Sentry.Severity.Error,
  formater: ExceptionFormater = getAPIErrorMessages
) {
  const error = new CustomError(formater(e), e);
  // NOT FOUND exceptions are just INFO level
  const level = e.status && e.status === 404 ? Sentry.Severity.Info : severity;
  error.setErrorLevel(level);

  if (process.env.NODE_ENV !== 'development') {
    Sentry.withScope(scope => {
      const state = store.getState();
      const userState = getUserInfo(state);
      scope.setLevel(level);
      scope.setExtra('Original error', e);
      scope.setExtra('Store session', sessionStoreSelector(state));
      scope.setUser(userState);
      Sentry.captureException(error);
    });
  } else {
    // eslint-disable-next-line no-console
    console.error(error);
  }

  return error;
}
